import { MatIconModule } from '@angular/material/icon';
import { LogoUploaderComponent } from './logo-uploader/logo-uploader.component';
import { SignupThankYouComponent } from './signup-thank-you/signup-thank-you.component';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SignupFormComponent } from './signup-form/signup-form.component';
import { ReactiveFormsModule } from '@angular/forms';

import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { TranslateModule } from '@ngx-translate/core';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { HttpClientModule } from '@angular/common/http';
import { RecaptchaModule } from 'ng-recaptcha';
import { ClientConfirmationComponent } from './client-confirmation/client-confirmation.component';
import { SubscriptionRenewalCancellationComponent } from './subscription-renewal-cancellation/subscription-renewal-cancellation.component';
import { SendOfferToClientComponent } from './send-offer-to-client/send-offer-to-client.component';
import { OfferFormComponent } from './offer-form/offer-form.component';
import { OfferThankYouComponent } from './offer-thank-you/offer-thank-you.component';
import { initializeApp,provideFirebaseApp } from '@angular/fire/app';
import { environment } from '../environments/environment';
import { provideFunctions,getFunctions } from '@angular/fire/functions';
import { provideStorage,getStorage } from '@angular/fire/storage';
import { AngularFireFunctionsModule, REGION } from '@angular/fire/compat/functions';
import { AngularFireStorageModule } from '@angular/fire/compat/storage';
import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import { AngularFireModule } from '@angular/fire/compat';
import {MatTooltipModule} from '@angular/material/tooltip';
import '@angular/common/locales/global/pl'

@NgModule({
  declarations: [
    AppComponent,
    SignupFormComponent,
    ClientConfirmationComponent,
    SignupThankYouComponent,
    SubscriptionRenewalCancellationComponent,
    SendOfferToClientComponent,
    OfferFormComponent,
    OfferThankYouComponent,
    LogoUploaderComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    TranslateModule.forRoot(),
    HttpClientModule,
    ReactiveFormsModule,
    MatButtonModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatCheckboxModule,
    MatSelectModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatTooltipModule,
    MatProgressSpinnerModule,
    RecaptchaModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireFunctionsModule,
    AngularFirestoreModule,
    AngularFireStorageModule,
    //  provide modular style for AppCheck
    // provideFirebaseApp(() => initializeApp(environment.firebase)),
    // provideFunctions(() => getFunctions()),
    // provideStorage(() => getStorage())
  ],
  providers: [
    // Set Firebase functions region
    { 
      provide: REGION, 
      useValue: environment.region 
    }, 
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
